import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import classNames from 'classnames'

import Select from 'component/Select/Select'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

const ALL = 'all'

class RegionBranchMultipleSelect extends Component {
  static propTypes = {
    required: PropTypes.bool,
    user: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    translate: PropTypes.func.isRequired,
    getAllCallback: PropTypes.func,
    initialValues: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    disabled: PropTypes.bool,
    excludeInactive: PropTypes.bool,
  }

  state = {
    options: [],
    error: null,
    loading: false,
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    const { user, excludeInactive } = this.props

    if (user) {
      this.setState({ loading: true })

      try {
        const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
        const { data } = await new Api(user.dsToken).post(endpoint)

        this.onFetchSuccess(data)
      } catch (error) {
        this.onFetchError(error)
      }
    }
  }

  onFetchSuccess = (companies) => {
    // const { getAllCallback } = this.props

    this.setState({
      loading: false,
      options: companies.map(({ id, name }) => ({
        label: `${id} - ${name}`,
        value: id,
      })),
    })
  }

  onFetchError = (error) => {
    this.setState({ error, loading: false, options: [] })
  }

  handleChange = (value) => {
    const { onChange, name, value: currentValue } = this.props

    const { options } = this.state

    const hasAllOption = Array.isArray(value) && value.some((v) => v.value === ALL || v === ALL)

    const availableOptions = currentValue && Array.isArray(currentValue)
      ? options.filter((opt) => !currentValue.some((v) => v.value === opt.value || v === opt.value))
      : options

    const isSelectingAll = Array.isArray(value) &&
                          value.length > 0 &&
                          value.length === availableOptions.length


    let event = { target: { name, value } }

    if (hasAllOption || isSelectingAll) {
      event = { target: { name, value: options } }
    }


    if (onChange) {
      onChange(event)
    }
  }

  filterOptions = (option, inputValue) => {
    inputValue = inputValue.toLowerCase()
    const lcLabel = option.label.toLowerCase()

    const matches = lcLabel.includes(inputValue)

    return matches && option.data.visible
  }

  renderOption = (option) => {
    const isBranchAndNotBold = option.isBranch && !option.isBold

    const className = classNames(
      { 'option-branch': isBranchAndNotBold },
      { 'option-region': !isBranchAndNotBold },
      { hidden: !option.visible }
    )

    return (
      <option value={option.value} className={className}>
        {option.label}
      </option>
    )
  }

  render() {
    const { label, value, required, translate, disabled } = this.props
    const { options, loading } = this.state

    const placeholderLabel = translate(
      loading ? 'loading' : 'choose.one.store'
    )

    const allSelected = value && Array.isArray(value) && value.length === options.length

    const filteredOptions = value && Array.isArray(value) && value.length > 0
      ? options.filter(
          (opt) => !value.some((v) => v.value === opt.value || v === opt.value)
        )
      : options

    return (
      <Select
        isMulti
        groupOptions
        label={label}
        placeholder={placeholderLabel}
        options={filteredOptions}
        allOptionsSelected={allSelected}
        value={value}
        onChange={this.handleChange}
        selectAll
        fill
        required={required}
        disabled={disabled}
      />
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

const RegionBranchMultipleSelectTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RegionBranchMultipleSelect)

export default connect(mapStateToProps)(RegionBranchMultipleSelectTranslated)

export { RegionBranchMultipleSelect }
